import React from "react";
import { CheckCircle2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { FUNCTIONS_EN, FUNCTIONS_TA, SERVICES_EN, SERVICES_TA } from "@/lib/translations";

export default function RoleOfDIC() {
    const { t, lang } = useLang();
    const functions = lang === "en" ? FUNCTIONS_EN : FUNCTIONS_TA;
    const services = lang === "en" ? SERVICES_EN : SERVICES_TA;

    return (
        <div data-testid="role-page">
            <section className="bg-[#1A365D] text-white pt-20 pb-16 md:pt-28 md:pb-24">
                <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
                    <div className="small-caps text-[#F5B76E] mb-4">{t.role.eyebrow}</div>
                    <h1 className="font-serif font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-4xl mb-6">
                        {t.role.title}
                    </h1>
                    <p className="max-w-3xl text-gray-300 leading-relaxed">
                        {t.role.subtitle}
                    </p>
                </div>
            </section>

            {/* Functions */}
            <section className="py-16 md:py-24 bg-white">
                <div className="max-w-6xl mx-auto px-6 md:px-12">
                    <div className="small-caps text-[#DD6B20] mb-3">Functions</div>
                    <h2 className="font-serif text-3xl md:text-4xl font-semibold text-[#1A365D] mb-12">
                        {t.role.functionsTitle}
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {functions.map((f, i) => (
                            <div
                                key={i}
                                className="flex gap-4 p-6 border border-gray-200 rounded-lg hover:border-[#1A365D] transition-colors"
                                data-testid={`function-${i}`}
                            >
                                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#F7FAFC] text-[#1A365D] flex items-center justify-center font-serif font-bold">
                                    {i + 1}
                                </div>
                                <div className="text-gray-700 leading-relaxed pt-1">{f}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Services */}
            <section className="py-16 md:py-24 bg-[#F7FAFC]">
                <div className="max-w-6xl mx-auto px-6 md:px-12">
                    <div className="small-caps text-[#DD6B20] mb-3">Services</div>
                    <h2 className="font-serif text-3xl md:text-4xl font-semibold text-[#1A365D] mb-12">
                        {t.role.servicesTitle}
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {services.map((s, i) => (
                            <div
                                key={i}
                                className="bg-white p-8 rounded-lg border border-gray-200 hover:border-[#DD6B20] transition-colors"
                                data-testid={`service-${i}`}
                            >
                                <CheckCircle2 size={22} className="text-[#DD6B20] mb-4" />
                                <h3 className="font-serif font-semibold text-xl text-[#1A365D] mb-3">
                                    {s.title}
                                </h3>
                                <p className="text-sm text-gray-600 leading-relaxed">{s.body}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
